// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"81":"6fd7eb82","453":"d54e35ae","461":"d49cf281","642":"2c721ed1"}[chunkId] + ".css";
};